import * as Yup from "yup";

export const buildQuickCategorySchema = (
  t: (key: string, fallback: string) => string
) =>
  Yup.object({
    name: Yup.string()
      .trim()
      .required(
        t("quick-add-category-name-required", "Category name is required")
      ),
    description: Yup.string().trim().optional(),
    parentId: Yup.string().trim().optional()
  });

export type QuickCategoryFormValues = {
  name: string;
  description?: string;
  parentId?: string;
};
